import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './EventPagination.module.scss';

const EventPagination = ({ 
  data, 
  pageSize = 20, 
  startingPage = 1, 
  children 
}) => {
  const [currentPage, setCurrentPage] = useState(null);
  const [pageCount, setPageCount] = useState(null);

  const updateCurrentPage = (dataLength, pageSize, startingPage) => {
    let calculatedPageCount = parseInt(dataLength / pageSize);
    if (dataLength % pageSize > 0) {
      calculatedPageCount++;
    }
    
    setCurrentPage(startingPage);
    setPageCount(calculatedPageCount);
  };

  // Initial setup - equivalent to componentDidMount
  useEffect(() => {
    updateCurrentPage(data.length, pageSize, startingPage);
  }, []);

  // Update when data changes - equivalent to componentDidUpdate
  useEffect(() => {
    updateCurrentPage(data.length, pageSize, startingPage);
  }, [data.length, pageSize, startingPage]);

  const generateLink = (targetPage, disabled = false, text = null) => {
    if (!text && (targetPage <= 0 || targetPage > pageCount)) return null;
    
    return (
      <button
        key={text || targetPage}
        disabled={disabled}
        className={classNames({ [s.active]: targetPage === currentPage, [s.numbers]: !text })}
        onClick={() => setCurrentPage(targetPage)}
      >
        {text || targetPage}
      </button>
    );
  };

  const paginationControls = () => {
    return (
      <div className={s.controls}>
        {generateLink(currentPage - 1, currentPage === 1, 'Prev')}
        <div className={s.pageLinks}>
          {generateLink(currentPage - 2)}
          {generateLink(currentPage - 1)}
          {generateLink(currentPage)}
          {generateLink(currentPage + 1)}
          {generateLink(currentPage + 2)}
        </div>
        {generateLink(currentPage + 1, currentPage === pageCount, 'Next')}
      </div>
    );
  };

  const paginatedData = () => {
    if (!currentPage) return [];
    
    const upperLimit = currentPage * pageSize;
    return data.slice(upperLimit - pageSize, upperLimit);
  };

  return (
    <div className={s.pagination}>
      {React.cloneElement(children, { events: paginatedData() })}
      {data.length > 0 && paginationControls()}
    </div>
  );
};

EventPagination.propTypes = {
  data: PropTypes.array.isRequired,
  pageSize: PropTypes.number,
  startingPage: PropTypes.number,
  children: PropTypes.element.isRequired
};

export default EventPagination;